// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fund-chart {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: stretch;
  width: 100%;
}

.fund-chart__plot {
  width: 100%;
}

.fund-chart__plot-loading {
  width: 100%;
  height: 240px;
  padding: 16px;
  box-sizing: border-box;
  div {
    display: flex;
    flex-direction: column;
    span {
      margin: auto;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/FundSummaryWidget/components/FundChart/FundChart.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB;IACE,aAAa;IACb,sBAAsB;IACtB;MACE,YAAY;IACd;EACF;AACF","sourcesContent":[".fund-chart {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: stretch;\n  width: 100%;\n}\n\n.fund-chart__plot {\n  width: 100%;\n}\n\n.fund-chart__plot-loading {\n  width: 100%;\n  height: 240px;\n  padding: 16px;\n  box-sizing: border-box;\n  div {\n    display: flex;\n    flex-direction: column;\n    span {\n      margin: auto;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
